import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=46f618a4&scoped=true"
import script from "./PriceFilter.vue?vue&type=script&lang=js"
export * from "./PriceFilter.vue?vue&type=script&lang=js"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=46f618a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@6.11.0_webpack@5.105.1__lodash@4_6fd9dbbebaebfbe303bf4cf98ec4c0cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f618a4",
  null
  
)

export default component.exports